import { createSlice } from "@reduxjs/toolkit";

const initialReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  reportForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const reportSlice = createSlice({
  name: "report",
  initialState: initialReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    reportFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    reportAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    reportCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.report.push(action.payload.report);
    },
    reportDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.report.filter(el => el.report_id !== action.payload.id);
    },
    getReport: (state, action) => {
      state.actionsLoading = false;
      state.reportForEdit = action.payload.reportForEdit;
      state.error = null;
    },
    // updateProduct
    reportUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.report = state.entities.report.map(entity => {
        if (entity.report_id === action.payload.report.report_id) {
          return action.payload.report;
        }
        return entity;
      });
    },
  },
});
